import { createTranslationService } from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';
import * as React from 'react';
import {
    ColumnDiv,
    FieldCell,
    FieldLabel,
    FlexWrapContainer,
    Step4Header,
    Step4SubTitle,
    Step4Title,
    SubTitle
} from './details-styles';
import FieldBuilder from '@components/field-builder';
import { Title } from './styles';
import {
    Field
} from '@models/field-builder/field';
import { observer } from 'mobx-react';
import { IRemoteRepresentativeStore } from '@stores/remote-representative/remote-representative-store';

interface Props {
    store: IRemoteRepresentativeStore;
}

enum Step4DetailsTranslation {
    firstName = 'firstName',
    lastName = 'lastName',
    familyName = 'familyName',
    givenName = 'givenName',
    middleInitial = 'middleInitial',
    section3SubTitle = 'section3SubTitle',
    section3SubTitleDesc = 'section3SubTitleDesc',
    newName = 'newName',
    dateRehire = 'dateRehire',
    ifApplicable = 'ifApplicable',
    dateFieldLabel = 'dateFieldLabel',
    dateFormatLabel = 'dateFormatLabel',
    section3PartCTitle = 'section3PartCTitle',
    ifAnyLabel = 'ifAnyLabel',
    iAttestText = 'iAttestText',
    signatureOfEmployer = 'signatureOfEmployer',
    todaysDateLabel = 'todaysDateLabel',
    nameOfEmployer = 'nameOfEmployer',
    documentNumber = 'documentNumber',
    expirationDate = 'expirationDate',
    documentTitle = 'documentTitle'
}

interface CheckFieldItemProps {
    label: string;
    subLabel?: string;
    fieldDefinition: Field;
    maxSize?: number;
}

const FieldItem: React.FunctionComponent<CheckFieldItemProps> = (props: CheckFieldItemProps) => {
    return (
        <FieldCell maxSize={props.maxSize}>
            <FieldLabel>{props.label}<i>{props.subLabel}</i></FieldLabel>
            <FieldBuilder fields={[props.fieldDefinition]}/>
        </FieldCell>);
};

const Step4Details = observer<React.FC<Props>>(({ store }: Props) => {
    const translations = cacheTranslations(
        createTranslationService(),
        Step4DetailsTranslation
    );
    return (
        <>
            <ColumnDiv>
                <Step4Header>
                    <Step4Title>{translations.section3SubTitle}</Step4Title>
                    <Step4SubTitle>{translations.section3SubTitleDesc}</Step4SubTitle>
                </Step4Header>
                <ColumnDiv>
                    <FlexWrapContainer>
                        <ColumnDiv proportion={60}>
                            <SubTitle>{translations.newName}<i>{translations.ifApplicable}</i></SubTitle>
                            <FlexWrapContainer>
                                <FieldItem label={translations.lastName}
                                           subLabel={translations.familyName}
                                           fieldDefinition={store.section3Fields[0]}/>

                                <FieldItem label={translations.firstName}
                                           subLabel={translations.givenName}
                                           fieldDefinition={store.section3Fields[1]}/>
                                <FieldItem label={translations.middleInitial}
                                           fieldDefinition={store.section3Fields[2]}/>
                            </FlexWrapContainer>
                        </ColumnDiv>
                        <ColumnDiv proportion={30}>
                            <SubTitle>{translations.dateRehire}<i>{translations.ifApplicable}</i></SubTitle>
                            <FlexWrapContainer>
                                <FieldItem label={translations.dateFieldLabel}
                                           subLabel={translations.dateFormatLabel}
                                           fieldDefinition={store.section3Fields[3]}/>
                            </FlexWrapContainer>
                        </ColumnDiv>
                    </FlexWrapContainer>
                </ColumnDiv>
            </ColumnDiv>
            <ColumnDiv topSpacing={true}>
                <SubTitle>{translations.section3PartCTitle}</SubTitle>
                <FlexWrapContainer>
                    <FieldItem label={translations.documentTitle}
                               fieldDefinition={store.section3Fields[4]}/>
                    <FieldItem label={translations.documentNumber}
                               fieldDefinition={store.section3Fields[5]}/>
                    <FieldItem label={translations.expirationDate}
                               subLabel={`${translations.ifAnyLabel} ${translations.dateFormatLabel}`}
                               fieldDefinition={store.section3Fields[6]}/>
                </FlexWrapContainer>
            </ColumnDiv>
            <Title>{translations.iAttestText}</Title>
            <ColumnDiv>
                <FlexWrapContainer>
                    <FieldItem label={translations.signatureOfEmployer}
                               fieldDefinition={store.section3Fields[7]}/>
                    <FieldItem label={translations.todaysDateLabel}
                               subLabel={translations.dateFormatLabel}
                               fieldDefinition={store.section3Fields[8]}/>
                    <FieldItem label={translations.nameOfEmployer}
                               fieldDefinition={store.section3Fields[9]}/>
                </FlexWrapContainer>
            </ColumnDiv>
        </>
    );
});

export default Step4Details;



// WEBPACK FOOTER //
// ./src/screens/review-section3/review/step4-details.tsx